import React from "react";

import supportPrograms from "src/data/app/programs";

interface ProgramBenefitsProps {
  supportProgramKey: string;
}

const ProgramBenefits: React.FC<ProgramBenefitsProps> = ({
  supportProgramKey,
}) => {
  const config =
    supportPrograms[supportProgramKey as keyof typeof supportPrograms];

  const benefits = config?.website?.benefits;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col items-center gap-4">
        <div className="mx-4 flex flex-col items-center gap-2">
          <h2 className="text-base font-medium text-center">
            Program Benefits
          </h2>
          <p className="text-sm font-light text-gray-500 text-center">
            Unlock these features once your documents are reviewed and approved
            by our medical team
          </p>
        </div>
        <div className="flex flex-col gap-2 w-full">
          {benefits?.benefits?.map((benefit: any, index: number) => (
            <div
              className="mx-4 border border-gray-200 rounded-lg p-4 bg-white"
              key={index}
            >
              <div className="flex flex-row items-center justify-between">
                <div className="flex flex-row items-start gap-2">
                  {benefit.icon && (
                    <div className="bg-[var(--icon-bg-primary)] rounded-md p-2">
                      <benefit.icon className="w-4 h-4 text-[var(--app-primary)]" />
                      {/* <img
                      src={benefit.image}
                      alt={benefit.title}
                      className="w-10 h-10 text-[var(--app-primary)]"
                    /> */}
                    </div>
                  )}
                  <div>
                    <p className="font-medium text-base mb-1">
                      {benefit.title}
                    </p>
                    <p className="text-sm font-light text-gray-500 mb-2">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgramBenefits;
